<template>
  <div class="academic">
    <h1 class="title">·行业资讯</h1>

    <div class="academic-list">
      <ul>
        <li class="active-item">
          <a target="view_window" href="https://mp.weixin.qq.com/s?__biz=MzIwMDk0MjkxNw==&mid=2247485227&idx=1&sn=ff5adb7c27fe899474693ffddd62b430&chksm=96f43301a183ba17f314e2fcfabdd44cae25310b0af9cf5ce25997ec1af0dc3c0fc0fc6047a1&token=1204762156&lang=zh_CN#rd">
            <p class="left">《重磅！教育部“2022新课标”出台，明确音乐、美术主线地位！》</p>
            <p class="right">2022-04-24</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="http://mp.weixin.qq.com/s?__biz=MzIwMDk0MjkxNw==&mid=100000630&idx=1&sn=78df65e3e339a2b81a6f2a22bbc43358&chksm=16f4375c2183be4abda57ab27389543b4acd2e43056d14b7efba61830c755ad2785195f92b6c#rd">
            <p class="left">今年全国两会，这些名校长、教授都说了啥？</p>
            <p class="right">2021-03-16</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="http://mp.weixin.qq.com/s?__biz=MzIwMDk0MjkxNw==&mid=100000622&idx=1&sn=83b115d82e91bf6a2a38b8176d38f071&chksm=16f437442183be52cb68426c4a3172b565f1a713a799a60767cb793c4518a4bb4c1244a6b4ec#rd">
            <p class="left">什么是好的教育？这位校长的话刷屏了</p>
            <p class="right">2020-03-12</p>
          </a>
        </li>
        <li class="active-item">
          <a @click="$router.push('/articleInfo4')" href="javascript:;">
            <p class="left">《新时代学校美育工作意见》发布，音乐艺术将纳入中考改革</p>
            <p class="right">2020-10-17</p>
          </a>
        </li>
        <li class="active-item">
          <a @click="$router.push('/articleInfo5')" href="javascript:;">
            <p class="left">收好你的考级证书，它可能是你考入名校的垫脚石！</p>
            <p class="right">2020-10-11</p>
          </a>
        </li>
        <li class="active-item">
          <a target="view_window" href="https://mp.weixin.qq.com/s/8pKLw-Oh2aitvk7crTaqJQ">
            <p class="left">武汉“新中考”音乐科目如何考？划重点来啦！</p>
            <p class="right">2020-08-28</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="less" scoped>
.academic {
  padding: 0 32px;
  min-height: 500px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.11);
  .title {
    position: relative;
    padding: 20px 0;
    color: #08433f;
    font-size: 25px;
    line-height: 55px;
    font-weight: bold;
    &:after {
      content: "";
      height: 5px;
      width: 100%;
      background: rgba(20, 146, 138, 1);
      z-index: 10;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    // padding: 25px 0 20px;
    color: #08433f;
    font-size: 25px;
    line-height: 55px;
  }

  .academic-list {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    padding-bottom: 149px;
    ul {
      display: block;
      width: 100%;
      .active-item {
        display: block;
        height: 70px;
        line-height: 70px;
        border-bottom: 1px solid #cecece;
        a {
          text-decoration: none;
          color: #4a4a4a;
          cursor: pointer;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          flex-wrap: nowrap;
          .right {
            width: 100px;
            text-align: right;
            font-size: 14px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(74, 74, 74, 1);
          }
          &:hover {
            color: #14928a;
          }
        }
      }
    }

    .acadmic-item {
      margin: 0 24px 20px;
      flex: 0 0 250px;
      box-shadow: 6px 2px 20px 0px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
      img {
        width: 250px;
        height: 354px;
      }
      p {
        width: 250px;
        line-height: 42px;
        padding: 0 8px;
        color: #444;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
  }
}
</style>

<script>
export default {
  name: "news",
  data() {
    return {};
  },
};
</script>
